import {FC} from 'react';
import {Box, Typography} from '@mui/material';
import {policySx} from './Policy.sx';

export const Policy: FC = () => {
    return (
        <Box>
            <Box sx={policySx.root}>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    AMP IT SA
                </Typography>
                <Typography variant="h2">Privacy Policy</Typography>

                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    <em>September 2026</em>
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    AMP IT SA and the companies of its group (hereinafter also individually or collectively "AMP IT",
                    "we", "our" or "us") collect and process personal data concerning you and concerning other
                    individuals ("third parties"). This privacy policy (data protection statement) may be supplemented
                    separately, for example in consent forms, general terms and conditions, additional statements and
                    other means of communication.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    If you provide us with data or share data concerning third parties with us, you confirm that you are
                    authorized to do so and that the data concerned is accurate. You are also invited to ensure that any
                    persons whose data is shared have been informed of this privacy policy.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    We are committed to processing personal data concerning you in a responsible manner. Accordingly, we
                    comply with the requirements of the Federal Act on Data Protection (FADP), the Ordinance to the
                    Federal Act on Data Protection (OFADP), the Telecommunications Act (TCA) and other provisions of
                    Swiss data protection legislation. With respect to the processing of personal data of data subjects
                    residing in the European Union, we also comply with the provisions of the General Data Protection
                    Regulation (GDPR).
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    1. Data Controller(s)
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    AMP IT SA, 1-3 Rue des Sablières, 1242 Satigny, Switzerland, is a company incorporated under Swiss
                    law whose purpose includes, in particular, the installation and management of charging stations for
                    electric vehicles, as well as the creation, development, operation and management of any software,
                    platforms or IT portals in any form and on any medium, in connection with its activities.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    It is the "data controller" for the purposes described below, unless it indicates otherwise to you
                    in a specific case, for example in specific privacy policies, on a form or in a contract. This means
                    that AMP IT SA alone is responsible for the manner in which it holds and uses personal data
                    concerning you.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    You may contact us for data protection questions and to exercise your rights under this privacy
                    policy at the following e-mail address: <a href="mailto:info@amp-it.ch">info@amp-it.ch</a>
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    2. Scope and Purpose of the Collection, Processing and Use of Personal Data
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    2.1 Collection and processing of personal data
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    We collect personal information concerning you in particular in the following cases and for the
                    purposes listed below:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    • Creating a customer account<br/>
                    • Communicating with the user<br/>
                    • Questions submitted via the contact form or in the context of exchanges for support services
                    (including with a chatbot)<br/>
                    • Data uploaded to your user account<br/>
                    • Verifying your identity<br/>
                    • Generating usage statistics<br/>
                    • Marketing and market research
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    The purposes and objectives of collecting personal data serve, in particular, our interests and
                    potentially those of third parties in connection with the performance of certain services. We
                    therefore process your data for the purposes of:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    • communicating with you, in particular to respond to your requests and to the exercise of your
                    rights, and to enable us to contact you in case of questions. For this purpose, we use in particular
                    communication data and basic data, as well as registration data relating to the offers and services
                    you use. We may retain such data to document communications with you for training, quality assurance
                    and/or follow-up purposes;<br/>
                    • entering into, administering and performing contractual relationships;<br/>
                    • marketing and relationship management;<br/>
                    • market research, to improve our services and our business activities, and for product
                    development;<br/>
                    • security and access control;<br/>
                    • complying with laws, directives and recommendations of the authorities and internal regulations
                    ("compliance with legal requirements");<br/>
                    • our risk management and corporate governance, including the organization and development of our
                    business.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    We may process your data for other purposes, for example in connection with our internal processes
                    and administration or for quality assurance and training purposes.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Where we request your consent for certain processing activities (for example for marketing
                    activities, for registration on the supplier management portal, for advertising management and
                    analysis of website behaviour), we inform you separately of the relevant processing purposes. You
                    may withdraw your consent at any time, with effect for the future, by sending us an e-mail at the
                    following address: <a href="mailto:info@amp-it.ch">info@amp-it.ch</a>. As soon as we have received
                    notice of the withdrawal of consent, we will no longer process your information for the purpose(s)
                    to which you had consented, unless we have another legal basis for doing so. Withdrawal of consent
                    does not, however, affect the lawfulness of processing based on consent before its withdrawal.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Where we do not request consent for processing, the processing of your personal data is based on the
                    necessity of the processing to enter into or perform a contract with you (or the entity you
                    represent), or on our legitimate interest or that of a third party in the processing in question, in
                    particular in pursuing the purposes and objectives set out in this privacy policy and in
                    implementing related measures. Our legitimate interests also include compliance with legal
                    regulations, to the extent this is not already recognized as a legal basis by applicable data
                    protection legislation (for example, in the case of the GDPR, the laws in the EEA, and in the case
                    of the FADP, Swiss law). This also includes the marketing of our services, the desire to better
                    understand our markets and to manage and develop our business, including its activities, in a safe
                    and efficient manner.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    2.2 Sharing of data
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    In connection with our contracts, the use of the Website, our services, our legal obligations, the
                    protection of our legitimate interests and the other purposes set out above, we may disclose your
                    personal data to third parties, in particular to the following categories of recipients:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    • Service providers: We work with service providers in Switzerland and abroad who process your data
                    on our behalf or as joint controllers with us, or who receive data concerning you from us as
                    independent controllers (for example IT providers, advertising service providers, IT security
                    companies, banks, insurance companies, debt-collection companies, credit reference agencies, or
                    address, identity and/or signature verification providers).<br/>
                    • Contractual partners, including customers: These are customers (for example, beneficiaries of
                    services) and our other contractual partners, to the extent that the disclosure of data results from
                    these contracts. For example, they receive registration data in connection with the supply of
                    products and services, etc. If you work for one of these contractual partners, we may also disclose
                    data concerning you to them. These recipients also include contractual partners with whom we
                    cooperate or who carry out advertising for us or other services on our behalf, and to whom we may
                    therefore disclose data concerning you for analysis, procurement and marketing purposes.<br/>
                    • Authorities: We may disclose personal data to agencies, courts, arbitral authorities and other
                    authorities in Switzerland and abroad if we are legally obliged or authorized to make such
                    disclosures or if this appears necessary to protect our interests. These authorities act as
                    independent controllers.<br/>
                    • Other persons: These are other cases in which interactions with third parties fall within the
                    scope of the purposes set out above, for example beneficiaries of services, media and associations
                    in which we participate, or if you appear in one of our publications.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    In addition, we allow certain third parties to collect your personal data on our website and at
                    events we organize (for example, tool providers on our website, etc.). Where we have no control over
                    such data collection, these third parties act as independent controllers. If you have any questions
                    or wish to exercise your data protection rights, we invite you to contact such third parties
                    directly.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    2.2.1 Visiting the Website
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    When you visit our website, our servers temporarily store the following data in what is known as a
                    server log file. This data is deleted as soon as it is no longer required for the purpose of its
                    collection:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    • IP address of the requesting computer<br/>
                    • Date and time of access or retrieval<br/>
                    • URL of the data retrieved<br/>
                    • Operating system, computer model and browser type used<br/>
                    • Country from which you access our website<br/>
                    • Name of your internet service provider<br/>
                    • Time difference from Greenwich Mean Time (GMT)<br/>
                    • Access status, HTTP status code<br/>
                    • Volume of data transferred<br/>
                    • Last website visited<br/>
                    • Browser settings<br/>
                    • Language and version of your browser software
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    The legal basis for the temporary storage of personal data and log files is legitimate interest and
                    the performance of a contractual relationship. It is in our legitimate interest to:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    • properly display the content of our website;<br/>
                    • optimize and promote the content of our website;<br/>
                    • provide authorities with the information necessary to bring proceedings in the event of a
                    cyberattack;<br/>
                    • continuously improve our offering and our website;<br/>
                    • collect statistical data.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    We use your data mainly to improve your experience as a customer and make it more user-friendly, to
                    communicate with you regarding your questions or requests, to provide you with information on
                    specific services or marketing campaigns, and to recommend products or services that may be of
                    interest to you.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    2.2.2 Newsletter
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    You may subscribe to our newsletter. To receive it, you must have created an account on our website
                    or our application. Your consent constitutes the legal basis for the processing of data once you
                    have subscribed to the newsletter. When you provide us with data concerning you, you authorize us to
                    use it to send you the newsletter with information concerning, for example, services, promotions,
                    events and news.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    In addition, the following data is collected at the time of subscription:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    • IP address of the requesting computer<br/>
                    • Date and time of subscription<br/>
                    • Origin of the subscription (e.g., website, waiting list)
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    This data is necessary to send newsletters and is processed on the basis of your consent. You may
                    unsubscribe from the newsletter and withdraw your consent at any time. You will also find a link to
                    the unsubscribe page in each newsletter. We retain data concerning you until you unsubscribe from
                    the newsletter.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    2.2.3 Services offered
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    2.2.3.1 General
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    If you wish to use our services, it is essential that you provide us with the data necessary to
                    process your request.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    We retain data concerning you in connection with our contractual obligations and delete it as soon
                    as we are no longer legally required to retain it. In the course of processing your file, the
                    service providers we use (such as banks, IT companies and payment service providers) are provided
                    with the data necessary for such processing. This data may include, in particular, your e-mail
                    address and telephone number, which allows us, for example, to contact you to resolve any issues.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    2.2.3.2 Creating a user account
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    By creating your customer account, access to which is secured by a password, you can view the
                    information and data you have stored.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    To create a customer account, the following information may, depending on the case, be collected:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    • E-mail address<br/>
                    • Password<br/>
                    • Title<br/>
                    • First name<br/>
                    • Last name<br/>
                    • Telephone number<br/>
                    • Home address<br/>
                    • Parking address
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    When a user deletes their account, the data linked to that account may be deleted, subject to the
                    retention requirements imposed by law. If you decide to delete your account, it is your
                    responsibility to first back up any data concerning you. We are entitled to irrevocably erase all
                    data retained during the period the user account was active.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    2.2.3.3 Virtual assistant (chatbot) and artificial intelligence
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    AMP IT provides its users with a virtual assistant based on artificial intelligence to respond to
                    support requests relating to its services. The assistant indicates, at the beginning of each
                    conversation, that it is an automated system, and you may at any time ask to be directed to a member
                    of staff. Use of the assistant is not mandatory.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    At your request, the assistant may also carry out certain operations on your account, such as
                    managing charging schedules or sending commands to a charging station. These operations are never
                    carried out automatically: they are presented to you and are only carried out after your explicit
                    confirmation, within the limits of your access rights. The data processed in this context is the
                    data you communicate during the conversation, as well as, depending on your access rights, certain
                    technical data necessary to process your request. This data is used to provide the requested
                    support, to follow up on it and to monitor its quality.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    The assistant is based on an artificial intelligence model provided by Anthropic (contracting entity
                    for Switzerland and the European Union: Anthropic Ireland, Limited), operated using Amazon Web
                    Services infrastructure. Requests are processed within data centers located in Switzerland and the
                    European Union, excluding any routing to regions outside this area. Each user is invited to review
                    the information and privacy policies relating to the services offered by Amazon Web Services (see in
                    particular <a
                    href="https://aws.amazon.com/compliance/gdpr-center/">https://aws.amazon.com/compliance/gdpr-center/</a>)
                    and by Anthropic Ireland, Limited (see in particular <a
                    href="https://www.anthropic.com/legal/privacy">https://www.anthropic.com/legal/privacy</a>).
                    Conversations are stored in AMP IT's own databases and are not accessible to either Amazon Web
                    Services or Anthropic, subject to applicable exceptions. They are not used to train artificial
                    intelligence models. They are retained for the period necessary for the purposes described above,
                    and you may delete your conversations at any time from your account.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    3. Deletion
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    We only process and store personal data concerning you for as long as necessary to achieve the
                    purpose of the collection, or in accordance with the legislation or regulations to which we are
                    subject. Once the purpose of storage ceases to exist, or once a prescribed retention period expires,
                    personal data is generally blocked or deleted. We also delete data concerning you if you request
                    this by sending us an e-mail at: <a href="mailto:info@amp-it.ch">info@amp-it.ch</a>, provided that
                    no legal or other obligation requires us to retain or keep such data.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    If personal data voluntarily saved in your personal account is deleted, only anonymized data will
                    remain stored following the deletion of the personal data.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    4. Disclosure to Third Parties
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    4.1 Principles
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    We only transmit data concerning you if you have formally consented to this, if the law so requires,
                    or if such disclosure relates to the use of our services, responding to questions, processing
                    requests or any services you have requested.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Not all recipients are located in Switzerland. Your data may therefore be processed both in Europe
                    and, in principle, in any country in the world. If a recipient is located in a country without
                    adequate legal data protection, we require the recipient to undertake to comply with applicable data
                    protection legislation, unless the recipient is already subject to a set of legally recognized rules
                    aimed at ensuring data protection, or unless we can rely on an exception. An exception applies, for
                    example, in the case of foreign legal proceedings, in the case of an overriding public interest, or
                    where the performance of a contract requires the disclosure of data, as well as if you have
                    consented to the transfer of data or if the data was made generally available by you directly and
                    you have not objected to its processing. Please note that data exchanged via the internet often
                    passes through third countries. Your data may therefore be sent abroad even if the sender and
                    recipient are located in the same country.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    We disclose your personal information to the following categories of recipients:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    • Service providers<br/>
                    • Business partners<br/>
                    • Identity verification partner companies<br/>
                    • Logistics partners<br/>
                    • Hosting partners<br/>
                    • Authorities and social insurance institutions (whether public or private)
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Where we engage subcontractors to provide our services, we undertake to take all precautions
                    required by law, as well as the corresponding technical and organizational security measures, to
                    ensure that personal data concerning you is protected in accordance with the relevant regulatory
                    provisions.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    4.2 Personal account
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    You are informed that data you voluntarily store in your personal account is hosted on AWS. If you
                    would like more information regarding the hosting of your data with AWS and its privacy policy,
                    please feel free to consult the following link: <a
                    href="https://aws.amazon.com/compliance/data-protection/">https://aws.amazon.com/compliance/data-protection/</a>
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    4.3 Use of specific services
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    AMP IT uses certain service providers/applications in connection with the automation of its
                    processes and the management of user accounts. You are informed that personal data may be shared
                    with these service providers for the performance of AMP IT's services on your behalf. You may at any
                    time request further information from AMP IT regarding these specific services and consult the
                    providers' privacy policies.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    As of the date of this policy, these providers include: Amazon Web Services (hosting and
                    infrastructure), Anthropic (artificial intelligence model for the virtual assistant), Stripe
                    (payment processing), Bexio (accounting and invoicing), Freshsales (customer relationship
                    management) and Google (website audience measurement, as well as the mobile application's Firebase
                    services: push notifications, usage statistics and crash reporting). The use of these providers is
                    limited to what is necessary for the provision of the relevant services. You are invited to consult
                    their privacy policies.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    5. Analytical Data
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Based on your consent, and by means of cookie technology, data is collected in order to optimize our
                    services and the user experience. This data is analytical and is not used to personally identify
                    you, but is used solely for a pseudonymous assessment of the use of the services. Data concerning
                    you is never merged with the personal data we retain.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    6. Cookies
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    6.1 What are cookies?
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Our website uses what are known as cookies. Cookies are information transmitted by our web server or
                    by third-party web servers to users' web browsers. This information is then stored in these browsers
                    before being retrieved later. It may take the form of small files or other information storage
                    media.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    6.2 Why do we use cookies?
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Cookies are used to optimize the information and offers displayed on our website in order to improve
                    your experience. They allow us to recognize visitors to our website. Thanks to this recognition,
                    your use of our website is made easier. Cookies strictly necessary for the functioning of the
                    website are placed on the basis of our legitimate interest. The audience-measurement cookies
                    described in section 7 are only placed with your consent.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    6.3 Which cookies do we use?
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    The website uses the following cookies:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    • Session cookies<br/>
                    • Persistent cookies<br/>
                    • Anonymous cookies<br/>
                    • Preference cookies<br/>
                    • Performance cookies<br/>
                    • Third-party cookies
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Temporary cookies are automatically deleted as soon as you close your browser. These include session
                    cookies. These store what is known as a session identifier, which allows various requests from your
                    browser to be associated with the corresponding session. They allow your computer to be recognized
                    when you return to the website. We use this type of cookie to ensure the proper functioning of our
                    website.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Persistent cookies, on the other hand, remain on your hard drive even after the session ends. These
                    cookies allow us, in particular, to make our offering more user-friendly, for example by remembering
                    your display preferences.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Anonymous cookies, such as statistical cookies, do not communicate any personal data to us. They
                    collect and return information anonymously and allow us to understand how visitors interact with web
                    pages. Preference cookies remember behavioural or display settings for a web page, your preferred
                    language, or the region in which you are located, for example.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    As for performance cookies, they help us gather information on how you use our services, allowing us
                    to improve them. We use them, for example, to determine whether you have viewed a particular page.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    6.4 Managing and refusing cookies
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    On your first visit, a banner allows you to accept or refuse cookies that are not strictly necessary
                    for the functioning of the website. Until you have given your consent, no audience-measurement
                    cookie is placed and no data is transmitted for this purpose. You may change or withdraw your choice
                    at any time, with effect for the future, using this banner or by deleting the cookies and site data
                    stored by your browser.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    It is not mandatory to accept cookies to consult our website. Most browsers automatically accept
                    cookies. If you do not wish to allow them, you can configure your browser to display the various
                    cookie settings options and only consent in certain cases. You can also configure it so that no
                    cookies are stored on your computer, or so that you receive an alert each time a new cookie is
                    created. Some browsers, for example, allow cookies from the site visited but block third-party
                    cookies.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    In addition, cookies already installed on your device can be deleted at any time from your browser
                    or other computer programs. All standard web browsers offer this option. You can set your browser to
                    permanently refuse all cookies.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    7. Web Analytics Tools
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    7.1 Principles
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Our website uses Google Analytics, the terms of which are described below. This tool is only
                    activated after you have given your consent.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    7.2 Google Analytics
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Based on your consent, we use Google Analytics 4, an audience-measurement service provided, for
                    users located in Switzerland and the European Economic Area, by Google Ireland Limited, Gordon
                    House, Barrow Street, Dublin 4, Ireland ("Google"). No audience-measurement cookie is placed and no
                    data is transmitted to Google before you have accepted the relevant cookies; for this purpose, we
                    use Google's consent management mechanism (Consent Mode v2), whose default settings refuse audience
                    measurement and advertising. You may withdraw your consent at any time, with effect for the future,
                    by changing your choice in our website's cookie banner or by deleting the cookies and site data
                    stored by your browser (section 6.4).
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Google uses cookies. Google processes the information thus collected on our behalf, for the purposes
                    of assessing your use of our online offering, compiling reports relating to such activities, and
                    providing us with other related services. In this context, pseudonymous user profiles may be created
                    from the data processed. These user profiles are automatically deleted at the end of the retention
                    period configured in our Google Analytics property, which is a maximum of fourteen months.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Google Analytics 4 does not record or retain IP addresses. For traffic originating from Switzerland,
                    the European Economic Area and the United Kingdom, geolocation lookup is performed on servers
                    located in these same regions, with the IP address deleted before any recording; only approximate
                    geolocation data (country, region, city) is derived from it. The IP address transmitted by the
                    user's browser is not merged with any other data provided by Google.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Certain data may be transferred to Google LLC in the United States, where it is stored. These
                    transfers are based on the adequacy decision of the Federal Council regarding the Swiss-U.S. Data
                    Privacy Framework, in force since 15 September 2024, as well as, for data subjects in the European
                    Union, on the adequacy decision of the European Commission of 10 July 2023 regarding the EU-U.S.
                    Data Privacy Framework, Google LLC being certified under these frameworks. On a subsidiary basis,
                    these transfers are based on the European Commission's standard contractual clauses.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    You may also block the collection of data generated by cookies and related to your use of our online
                    offering, as well as the processing of this data by Google, by clicking on the link below. Download
                    and install the browser extension at: <a
                    href="http://tools.google.com/dlpage/gaoptout?hl=en">http://tools.google.com/dlpage/gaoptout?hl=en</a>.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    To find out more about how Google uses your data and about the settings available, please consult
                    the following Google websites:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    • <a
                    href="https://www.google.com/intl/en/policies/privacy/partners">https://www.google.com/intl/en/policies/privacy/partners</a> (data
                    processing by Google when you use websites or our application partners),<br/>
                    • <a
                    href="http://www.google.com/policies/technologies/ads">http://www.google.com/policies/technologies/ads</a> (use
                    of data for advertising purposes),<br/>
                    • <a href="http://www.google.com/settings/ads">http://www.google.com/settings/ads</a> (managing the
                    information Google uses to display advertisements to you).
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    8. Your Rights
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    You have the following rights with respect to data concerning you: access to information relating to
                    data retained, rectification, deletion, restriction, transfer, objection and withdrawal. If you
                    believe that the processing of data concerning you infringes data protection legislation, or that
                    your rights in this respect have not been respected, you may lodge a complaint with the supervisory
                    authority. If you are located in the EEA or in Switzerland, you also have the right to lodge a
                    complaint with the competent data protection supervisory authority in your country. You will find a
                    list of authorities in the EEA here: <a
                    href="https://edpb.europa.eu/about-edpb/board/members_en">https://edpb.europa.eu/about-edpb/board/members_en</a>.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    You can contact the Swiss supervisory authority at the following address: <a
                    href="https://www.edoeb.admin.ch/edoeb/en/home/the-fdpic/contact.html">https://www.edoeb.admin.ch/edoeb/en/home/the-fdpic/contact.html</a>.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Applicable data protection laws give you the right to object to the processing of your data in
                    certain circumstances, in particular processing for direct marketing purposes, profiling for direct
                    marketing purposes and other legitimate interests in processing.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    To help you control the processing of your personal data, you have the following rights with respect
                    to our processing of your data, in accordance with applicable data protection legislation:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    • The right to ask us for information as to whether we process data concerning you and, if so, which
                    data;<br/>
                    • The right to request that we correct data if it is inaccurate;<br/>
                    • The right to request the deletion of data;<br/>
                    • The right to request that we provide certain personal data in a commonly used electronic format,
                    or that we transfer it to another controller;<br/>
                    • The right to withdraw your consent, where our processing is based on your consent;<br/>
                    • The right to receive, upon request, other information useful for the exercise of these rights.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    If you wish to exercise the above-mentioned rights against us, you may contact us in writing at our
                    address or, unless otherwise indicated or agreed, by e-mail. In order to prevent any abuse, we must
                    identify you (for example, by means of a copy of your identity card, if identification is not
                    otherwise possible).
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    You also have these rights against other parties who cooperate with us as independent controllers —
                    you may contact them directly if you wish to exercise your rights in relation to their processing of
                    your data. You will find information on our main partners and service providers above.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Please note that conditions, exceptions and restrictions may apply in the exercise of these rights
                    in accordance with applicable data protection legislation (for example, to protect third parties or
                    trade secrets). Where applicable, we will inform you accordingly.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    For any questions, suggestions or requests, please contact us at: <a
                    href="mailto:info@amp-it.ch">info@amp-it.ch</a>.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    Please note that the law requires certain data to be retained for a specific period. We are
                    therefore obliged to retain such data until that period expires. We lock such data in our IT systems
                    and use it solely to comply with legal requirements.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    9. Use of the Website by Minors
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    The services offered are intended for an adult audience. Minors are prohibited from providing us
                    with information that would allow them to be identified, or from logging in to use our services. If
                    we notice the presence of such information in our databases, we will delete it immediately. The
                    child's father, mother or legal representative is entitled to contact us to request the deletion of
                    the data or of the user account created. In such a case, the person making the request must provide
                    us with official proof of their status as parent or legal representative.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    10. Data Security
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    We take all necessary technical and organizational precautions to protect personal data concerning
                    you against falsification, loss, destruction or access by unauthorized persons, in order to
                    guarantee your rights and to comply with applicable data protection legislation.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    The measures taken are intended to ensure the confidentiality and integrity of data concerning you,
                    as well as the long-term availability and stability of our systems and services in connection with
                    the processing of such data. They also ensure the rapid restoration of the availability of, and
                    access to, data in the event of a physical or technical incident. Our data processing and security
                    measures are constantly improved in line with technological progress.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    We also take the protection of our own company's confidential data very seriously. Our employees, as
                    well as the service providers we engage, are bound by a duty of confidentiality and are required to
                    comply with data protection regulations. They also only have access to personal data to the extent
                    necessary for their work.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policySx.paragraph}
                >
                    11. Changes to the Privacy Policy
                </Typography>
                <Typography
                    variant="body2"
                    sx={policySx.paragraph}
                >
                    AMP IT may amend this privacy policy at any time. Such amendments are at AMP IT's sole discretion.
                    The version in force is the one published on our website and in our applications; it bears the date
                    shown at the head of this document.
                </Typography>
            </Box>
        </Box>
    );
};